import React from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import Typography from 'src/components/10-atoms/typography/Typography';
import AppAssets from 'src/constants/appAssets';
import palette from 'src/customizations/themes/10-parts/color-schemes/palette';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import FitImage from '../10-atoms/image/FitImage';
const EmptyList = ({ imgSrc = AppAssets.notFound, message, children, style, ...columnProps }) => {
    const [{ styles }] = useTheme(stylesGenerator);
    return (React.createElement(Column, { ...columnProps, xAxis: "center", spacing: 36, style: [styles.container, style] },
        React.createElement(Column, { xAxis: "center", spacing: 12, style: styles.content },
            React.createElement(FitImage, { source: { uri: imgSrc }, style: styles.image }),
            React.createElement(Typography, { variant: TypographyVariant.EMPTY_MSG, style: styles.text }, message),
            children)));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    container: {
        marginVertical: 56,
    },
    content: {
        width: '80%',
        maxWidth: 400,
    },
    image: {
        height: 'auto',
        width: '100%',
        borderRadius: theme.borderRadius.standard.lg,
        overflow: 'hidden',
        backgroundColor: palette.grey[50],
    },
    text: {
        textAlign: 'center',
    },
}));
export default EmptyList;
